import { Component, Input } from '@angular/core';

@Component({
  selector: 'sigecom-card',
  templateUrl: './card.component.html',
})
export class CardComponent {
}
